import { twMerge } from 'tailwind-merge'

import { textColor } from '@nxt-insurance/ui-kit/styles/colors'

import type { SvgProps } from '@/components/renderers/MultiColoredImage/types'

const defaultWidth = 285
const defaultHeight = 52

const Stars = (props: SvgProps) => {
  const width = props.width ?? defaultWidth
  const height = props.height ?? defaultHeight
  return (
    <svg
      className={twMerge('block w-auto', textColor({ color: props.color }))}
      width={width}
      height={height}
      viewBox="0 0 285 52"
      preserveAspectRatio="none"
    >
      <path
        d="M259.78 4.98847L263.692 17.0287C264.017 18.0292 264.95 18.7066 266.002 18.7066L278.662 18.7066C279.446 18.7066 279.772 19.7099 279.137 20.1708L268.895 27.6121C268.044 28.2304 267.688 29.3264 268.013 30.3269L271.925 42.3671C272.168 43.1129 271.314 43.733 270.68 43.2721L260.438 35.8308C259.587 35.2125 258.434 35.2125 257.583 35.8308L247.341 43.2721C246.707 43.733 245.853 43.1129 246.096 42.3672L250.008 30.3269C250.333 29.3264 249.977 28.2304 249.126 27.6121L238.883 20.1708C238.249 19.7099 238.575 18.7066 239.359 18.7066L252.019 18.7066C253.071 18.7066 254.003 18.0292 254.328 17.0287L258.241 4.98847C258.483 4.24276 259.538 4.24276 259.78 4.98847Z"
        fill="#ffffff"
        strokeWidth="1.61881"
      />
      <path
        d="M201.2 4.05529L205.487 17.249C205.769 18.1181 206.579 18.7066 207.493 18.7066L221.366 18.7066C221.841 18.7066 222.038 19.3147 221.654 19.5941L210.431 27.7482C209.691 28.2854 209.382 29.2375 209.664 30.1066L213.951 43.3003C214.098 43.7523 213.581 44.1282 213.196 43.8488L201.973 35.6947C201.234 35.1575 200.233 35.1575 199.493 35.6947L188.27 43.8488C187.886 44.1282 187.368 43.7523 187.515 43.3003L191.802 30.1066C192.085 29.2375 191.775 28.2854 191.036 27.7482L179.813 19.5941C179.428 19.3147 179.626 18.7066 180.101 18.7066L193.974 18.7066C194.887 18.7066 195.697 18.1181 195.98 17.249L200.267 4.05529C200.414 3.6033 201.053 3.6033 201.2 4.05529Z"
        strokeWidth="1.61881"
        fill="currentColor"
      />
      <path
        d="M142.922 4.05529L147.209 17.249C147.492 18.1181 148.301 18.7066 149.215 18.7066L163.088 18.7066C163.563 18.7066 163.761 19.3147 163.376 19.5941L152.153 27.7482C151.414 28.2854 151.104 29.2375 151.387 30.1066L155.674 43.3003C155.821 43.7523 155.303 44.1282 154.919 43.8488L143.696 35.6947C142.956 35.1575 141.955 35.1575 141.216 35.6947L129.993 43.8488C129.608 44.1282 129.091 43.7523 129.238 43.3003L133.525 30.1066C133.807 29.2375 133.498 28.2854 132.758 27.7482L121.535 19.5941C121.151 19.3147 121.348 18.7066 121.823 18.7066L135.696 18.7066C136.61 18.7066 137.42 18.1181 137.702 17.249L141.989 4.05529C142.136 3.6033 142.775 3.6033 142.922 4.05529Z"
        strokeWidth="1.61881"
        fill="currentColor"
      />
      <path
        d="M84.6447 4.05529L88.9316 17.249C89.214 18.1181 90.0239 18.7066 90.9378 18.7066L104.81 18.7066C105.286 18.7066 105.483 19.3147 105.099 19.5941L93.8756 27.7482C93.1363 28.2854 92.8269 29.2375 93.1093 30.1066L97.3962 43.3003C97.543 43.7523 97.0257 44.1282 96.6412 43.8488L85.418 35.6947C84.6787 35.1575 83.6776 35.1575 82.9382 35.6947L71.715 43.8488C71.3305 44.1282 70.8132 43.7523 70.96 43.3003L75.2469 30.1066C75.5293 29.2375 75.22 28.2854 74.4807 27.7482L63.2574 19.5941C62.8729 19.3147 63.0705 18.7066 63.5458 18.7066L77.4185 18.7066C78.3323 18.7066 79.1422 18.1181 79.4246 17.249L83.7115 4.05529C83.8584 3.6033 84.4978 3.6033 84.6447 4.05529Z"
        strokeWidth="1.61881"
        fill="currentColor"
      />
      <path
        d="M26.3676 4.05529L30.6545 17.249C30.9369 18.1181 31.7468 18.7066 32.6607 18.7066L46.5334 18.7066C47.0086 18.7066 47.2062 19.3147 46.8217 19.5941L35.5985 27.7482C34.8592 28.2854 34.5498 29.2375 34.8322 30.1066L39.1191 43.3003C39.2659 43.7523 38.7486 44.1282 38.3641 43.8488L27.1409 35.6947C26.4016 35.1575 25.4005 35.1575 24.6611 35.6947L13.4379 43.8488C13.0534 44.1282 12.5361 43.7523 12.6829 43.3003L16.9698 30.1066C17.2522 29.2375 16.9429 28.2854 16.2036 27.7482L4.98031 19.5941C4.59582 19.3147 4.79343 18.7066 5.26867 18.7066L19.1414 18.7066C20.0552 18.7066 20.8651 18.1181 21.1475 17.249L25.4344 4.05529C25.5813 3.6033 26.2207 3.6033 26.3676 4.05529Z"
        strokeWidth="1.61881"
        fill="currentColor"
      />
      <mask
        style={{ maskType: 'alpha' }}
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="237"
        y="3"
        width="44"
        height="42"
      >
        <path
          d="M259.78 4.98847L263.692 17.0287C264.017 18.0292 264.95 18.7066 266.002 18.7066L278.662 18.7066C279.446 18.7066 279.772 19.7099 279.137 20.1708L268.895 27.6121C268.044 28.2304 267.688 29.3264 268.013 30.3269L271.925 42.3671C272.168 43.1129 271.314 43.733 270.68 43.2721L260.438 35.8308C259.587 35.2125 258.434 35.2125 257.583 35.8308L247.341 43.2721C246.707 43.733 245.853 43.1129 246.096 42.3672L250.008 30.3269C250.333 29.3264 249.977 28.2304 249.126 27.6121L238.883 20.1708C238.249 19.7099 238.575 18.7066 239.359 18.7066L252.019 18.7066C253.071 18.7066 254.003 18.0292 254.328 17.0287L258.241 4.98847C258.483 4.24276 259.538 4.24276 259.78 4.98847Z"
          fill="#FFDF82"
          stroke="#FFDF82"
          strokeWidth="1.61881"
        />
      </mask>
      <g mask="url(#mask0)">
        <rect x="236" width="35.5" height="49" rx="1.3" />
      </g>
    </svg>
  )
}

export default Stars
